import React from 'react'
import { useSelector } from 'react-redux'
import CheckoutFrame from '../components/CheckoutFrame'
import Button from 'src/components/common/Button'
import SuccessImage from 'src/assets/checkout-success.jpg'
import { userSelector } from 'src/selectors'
import styles from './checkout-success.scss'
import cn from 'classnames'
import PropTypes from 'prop-types'
import { PlanSlugs } from 'src/services/stripe_checkout_configs'

const PlanLabelMapping = {
  [PlanSlugs.EssentialsMonthly]: 'Essentials Month-to-Month',
  [PlanSlugs.EssentialsAnnually]: 'Essentials Annual',
  [PlanSlugs.PremiumAnnually]: 'Premium Annual'
}

const CheckoutSuccess = ({ type, onClose }) => {
  const currentSub = useSelector(state => userSelector(state)?.current_subscription)

  const renderCreditsInfo = () => {
    return (
      <section className={cn(styles['section'])}>
        <h1>You have more credits! 🎉</h1>
        <p>The more the merrier! Now you can send more Smart Invites!</p>
        <p>Press the button below and send the remaining invites.</p>
      </section>
    )
  }

  const renderMembershipInfo = () => {
    const planLabel = PlanLabelMapping[currentSub.plan.slug] || ''
    return (
      <section className={cn(styles['section'])}>
        {planLabel && <h1>You are now an {planLabel} subscriber! 🎉</h1>}
        <p>Press the button below and send the remaining invites.</p>
      </section>
    )
  }

  return (
    <>
      <CheckoutFrame
        left={
          <>
            <main className={styles['main-container']}>
              {type === 'credits' && renderCreditsInfo()}
              {type === 'membership' && renderMembershipInfo()}
              <section className={cn(styles['section'], styles['btn-finish-container'])}>
                <Button className={styles['btn-finish']} onClick={onClose}>
                  FINISH SENDING INVITES
                </Button>
              </section>
            </main>
          </>
        }
        right={
          <>
            <img src={SuccessImage} alt="success!" />
          </>
        }
      />
    </>
  )
}

CheckoutSuccess.propTypes = {
  type: PropTypes.string,
  onClose: PropTypes.func
}

export default CheckoutSuccess
